import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { FLYER_ELEMENT_DEFAULT, FLYER_ELEMENT_IMAGE_DEFAULT } from '../../../constants/state'
import EditElement from '../../PageEditItem/present/EditElement'
import { addFlyerElement } from '../../../actions'
import { IMAGE } from '../../../constants/itemTypes'

const mapDispatchToProps = (dispatch, ownProps) => ({
    addFlyerItem: (item, elementType) => {
        dispatch(addFlyerElement(elementType, item))
    }
})

const AddImageContainer = ({addFlyerItem, itemType, closePagePath, itemData}) => (
    <EditElement 
        closePagePath={closePagePath}
        itemType={itemType}
        itemData={itemType === IMAGE ? FLYER_ELEMENT_IMAGE_DEFAULT : FLYER_ELEMENT_DEFAULT}
        onUpdateItem={addFlyerItem}
    />
)

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(AddImageContainer)